import { StudentScorePage } from "@/pages/teacher/StudentScorePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/classrooms/$classroomId/students/$studentId/score/")(
  {
    component: RouteComponent,
  }
);

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return <StudentScorePage classroomId={classroomId} studentId={studentId} />;
}
